import { render, staticRenderFns } from "./ChatMe.vue?vue&type=template&id=f9ab4acc&scoped=true"
import script from "./ChatMe.vue?vue&type=script&lang=js"
export * from "./ChatMe.vue?vue&type=script&lang=js"
import style0 from "./ChatMe.vue?vue&type=style&index=0&id=f9ab4acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ab4acc",
  null
  
)

export default component.exports